// A plan that still covers downloads: active, or cancelled but paid through
// the end of its period (the server counts both).
export const planIsLive = (user) => ["active", "cancelling"].includes(user?.subscription?.status);

// The signed-in user's free-download pool: a live plan's remaining
// downloads, else the account downloads an admin gifted (bonusDownloads,
// no plan attached). -1 means unlimited.
export function freeDownloadCount(user) {
  const sub = user?.subscription;
  if (planIsLive(user)) {
    const r = sub.downloads_remaining;
    return r === -1 ? -1 : Math.max(0, r || 0);
  }
  return Math.max(0, user?.bonusDownloads || 0);
}

export const hasFreeDownloads = (user) => freeDownloadCount(user) !== 0;

// The account balance (loaded on the billing page): documents spend their
// exact price from it when neither a plan nor gifted downloads cover them.
export const walletBalance = (user) => Math.max(0, (user?.walletCents || 0) / 100);

// Whether this order (of `count` documents) is covered without new payment,
// and by what. Downloads that can't cover the whole order leave it to the
// balance, as the server does.
export function coverage(user, orderTotal = 0, count = 1) {
  const n = Math.max(1, count);
  const free = freeDownloadCount(user);
  if (free === -1 || free >= n) {
    return { covered: true, source: planIsLive(user) ? "plan" : "bonus" };
  }
  // a plan that's run short falls back to gifted downloads first
  if ((user?.bonusDownloads || 0) >= n) return { covered: true, source: "bonus" };
  if (orderTotal > 0 && walletBalance(user) >= orderTotal) {
    return { covered: true, source: "wallet" };
  }
  return { covered: false, source: null };
}
